import React from "react";
import { Button, Dialog } from "../../../components/ds";

const SurveyCompletionModal = ({
  visible,
  icon,
  title,
  description,
  primaryBtnText,
  primaryBtnAction,
  secondaryBtnText,
  secondaryBtnAction,
  width = 617,
}) => {
  return (
    <Dialog
      open={Boolean(visible)}
      onClose={secondaryBtnAction}
      width={width}
      title={
        <div className="title-container assessment-dialog-title">
          {icon && icon}
          <span className="good-job-title">{title}</span>
        </div>
      }
      footer={
        <div className="modal-btn-group">
          {secondaryBtnText && (
            <Button variant="secondary" onClick={secondaryBtnAction}>
              {secondaryBtnText}
            </Button>
          )}
          {primaryBtnText && (
            <Button variant="primary" onClick={primaryBtnAction}>
              {primaryBtnText}
            </Button>
          )}
        </div>
      }
    >
      <div className="assessment-completion good-job-modal-wrapper">
        <div className="good-job-description">{description}</div>
      </div>
    </Dialog>
  );
};

export default SurveyCompletionModal;
